import React from 'react';
import { CardItemStyle } from '../../models/subchannel';
import { FeedInstance } from '../../models/feed';
import s from './BaseComp.scss';
import { ItemDispatcher, ItemLoadingDispatcher, SubChannelTitle } from './Common';

interface Props {
    name: string,
    link: string,
    articles: FeedInstance[],
    displays: CardItemStyle[],
    isLoading: boolean,
    isError: boolean,
}

export const GroupContainer = (props: Props) => {
    const { name, displays, link, isLoading, articles = [], isError } = props;
    let dispatcher = ItemDispatcher;
    if (isLoading) {
        dispatcher = ItemLoadingDispatcher;
    }
    if (isError) {
        return null;
    }
    return (
        <div className={s.group}>
            <div className={s.name}>
                <SubChannelTitle isLoading={isLoading} name={name} link={link} />
            </div>
            <div className={s.content}>
                {
                    displays.map((display, index) =>
                        <div key={index} className={s.itemBox}>{dispatcher(display, articles[index], index)}</div>,
                    )
                }
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/GroupContainer.tsx